<script>
  import jsondiffpatch from 'jsondiffpatch';
  import "jsondiffpatch/dist/formatters-styles/annotated.css";
  import "jsondiffpatch/dist/formatters-styles/html.css";

  export let current;
  export let compare;
  export let propertyId;

  let htmlDiff = '';
  $: {
    const rawDiff = jsondiffpatch.diff(current, compare);
    htmlDiff = jsondiffpatch.formatters.html.format(rawDiff, compare);
  }
</script>

<div>
  <div class="property-id">{propertyId}</div>
  <div class="diff">{@html htmlDiff}</div>
</div>

<style>
  .property-id {
    font-weight: bold;
    margin: 0.25em auto;
  }

  .diff {
    border: 2px solid lightgray;
    padding: 0.25em;
  }

  :global(.diff .jsondiffpatch-property-name) {
    display: none;
  }
</style>
